export const iconFontAwesomeTravelHotelTrain = (
	<i className="fa-solid fa-train"></i>
);
